import { Components, Theme } from '@mui/material';

const MuiInputAdornment: Components<Theme>['MuiInputAdornment'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      margin: 0,
      gap: theme.spacing(theme.spacingSizes.xs),
    }),
  },
};

export default MuiInputAdornment;
